export const en = {
    'banner-archived': 'Archiving ad',
    'banner-hide': 'Ads stopped',
    'banner-show': 'Ads activated',
    'banner-unarchived': 'Unarchiving ad',
    bannerNo: 'Ad №',
    broadmatch: 'Related keywords',
    'campaign-archived': 'Archiving campaign',
    'campaign-creation': 'Create campaign',
    'campaign-hide': 'Campaign stopped',
    'campaign-show': 'Campaign activated',
    'campaign-unarchived': 'Unarchiving campaign',
    campaignFinish: 'Campaign end date',
    campaignStart: 'Campaign start date',
    changes: 'Changed parameters',
    cid: 'Campaign №',
    demography: 'Bid adjustments for gender and age',
    disabledDomains: 'Blocked sites',
    disabledIps: 'Blocked IP addresses',
    disabledSsp: 'Blocked ad exchanges',
    extendedGeo: 'Extended geotargeting',
    groupNo: 'Group №',
    minusWords: 'Negative keywords for campaign',
    mobileMultipliers: 'Bid adjustments for mobile',
    network: 'Settings in ad networks',
    objects: 'Objects',
    perfomanceMultipliers: 'Bid adjustments for smart ads',
    regions: 'Display region',
    restrictFrequency: 'Impression frequency limit',
    retargeting: 'Bid adjustments for retargeting',
    settings: 'Settings',
    statuses: 'Statuses',
    strategy: 'Strategy',
    timeTargeting: 'Time targeting',
    userName: 'Changed by',
    videoMultipliers: 'Bid adjustments for video extensions'
};
